import * as dayjs from 'dayjs';
import { MapUtils } from '../../utility/map-utils.js';
import { TimeZone } from '../../time/timezone.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';

/**
 * @deprecated Use `webRoute` field of Discoverable instead.
 */
export class BusinessRoute extends DataModel {
  static readonly TYPE_ID: string = '2c57cdaaccd8435fb55b745a52b95a7e';

  constructor(
    public readonly uniqueId: string,
    public readonly businessId: string,
    public readonly creationDate: dayjs.Dayjs,
    public readonly redirectTo: string | null,
    public readonly allowWebBooking: boolean,
    public readonly isReadyForOnlineBooking: boolean,
  ) {
    super();
  }

  get $typeId(): string {
    return BusinessRoute.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): BusinessRoute {
    return new BusinessRoute(
        MapUtils.get<string>(map, 'uniqueId'),
        MapUtils.get<string>(map, 'businessId'),
        context.decodeDate(MapUtils.get<number>(map, 'creationDate')),
        MapUtils.getOrNull<string>(map, 'redirectTo'),
        MapUtils.get<boolean>(map, 'allowWebBooking'),
        MapUtils.get<boolean>(map, 'isReadyForOnlineBooking'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'businessId': this.businessId,
      'creationDate': context.encodeDate(this.creationDate),
      'redirectTo': this.redirectTo,
      'allowWebBooking': this.allowWebBooking,
      'isReadyForOnlineBooking': this.isReadyForOnlineBooking,
    };
  }

  clone(): this {
    return new BusinessRoute(
        this.uniqueId,
        this.businessId,
        TimeZone.cloneDate(this.creationDate),
        this.redirectTo,
        this.allowWebBooking,
        this.isReadyForOnlineBooking,
    ) as this;
  }

  isSame(other: BusinessRoute): boolean {
    if(this === other) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
        other.businessId === this.businessId &&
        other.creationDate === this.creationDate &&
        other.redirectTo === this.redirectTo &&
        other.allowWebBooking === this.allowWebBooking &&
        other.isReadyForOnlineBooking === this.isReadyForOnlineBooking;
  }
}

export class BusinessRouteBuilder extends DataModelBuilder<BusinessRoute> {
  build(context: SerializationContext, map: SerializedData): BusinessRoute {
    return BusinessRoute.fromMap(context, map);
  }
}
